<template>
  <section class="py-5">
    <list-quotes
      ref="requestQuotes"
      title="Solicitar Cotización"
      :requestingUserModule="true"
    >
      <template v-slot:actions>
        <v-col cols="12" md="12" sm="12">
          <v-btn @click="openModalCreateRequestQuote" color="primary" small>
            <v-icon small class="mr-1"> mdi-plus </v-icon>
            Crear solicitud
          </v-btn>
        </v-col>
      </template>
    </list-quotes>
    <modal-create-request-quote
      ref="modalCreateRequestQuote"
      :modalAction="dialogCreateRequestQuote"
      :closeModalCreateRequestQuote="closeModalCreateRequestQuote"
      @requestQuoteCreated="getRequestQuotes"
    ></modal-create-request-quote>
  </section>
</template>

<script>
import ModalCreateRequestQuote from "./ModalCreateRequestQuote.vue";
import { authUsuarioComputed } from "@/state/helpers";
import { TYPE_REQUESTS_MATERIALS } from "@/constants/requestMaterial";
import ListQuotes from "./ListQuotes.vue";

export default {
  components: {
    ModalCreateRequestQuote,
    ListQuotes,
  },
  data() {
    return {
      TYPE_REQUESTS_MATERIALS,
      dialogCreateRequestQuote: false,
    };
  },
  methods: {
    openModalCreateRequestQuote() {
      this.dialogCreateRequestQuote = true;
      this.$refs.modalCreateRequestQuote.resetFormCreateRequestQuote();
    },
    closeModalCreateRequestQuote() {
      this.dialogCreateRequestQuote = false;
    },
    async getRequestQuotes() {
      await this.$refs.requestQuotes.getRequestsQuotesData();
    },
  },
  computed: {
    ...authUsuarioComputed,
  },
};
</script>

<style></style>
